import { Pregunta } from './pregunta.model';

export class Plantilla {
  preguntas: Pregunta[] = [];
}
